module.exports = __webpack_public_path__ + "static/media/bg.f849c1ee.png";